




















import infoBlock from 'src/components/InfoBlock/InfoBlock.vue'
import helpPopover from '@/components/Ui/HelpPopover/HelpPopover.vue'
import Mailing from '@/models/mailing/mailing'
import Vue from 'vue'
export default Vue.extend({
  props: {
    scope: {} as () => {mailing: Mailing},
    options: {}
  },
  data () {
    return {

    }
  },
  components: {
    infoBlock,
    helpPopover
  },
  computed: {
    rating () {
      return this.scope.mailing.getRating();
    }
  }
})
